module.exports = __webpack_public_path__ + "img/Intellipure-468.9ee6d0a0.png";